<form [formGroup]="form">
    <div class="row">
        <div class="col s4">
            <app-input-switch formControlName="isSet"
                              [formControl]="form.controls.isSet"
                              (inputChange)="onSwitch($event)"
                              [(ngModel)]="tool.isSet"
                              topLabel="{{'admin.tools.form.labels.isSet' | translate }}"></app-input-switch>
        </div>
        <ng-container *ngIf="form.get('isSet').value">
            <div class="col s4">
                <app-input formControlName="setSize"
                           [(ngModel)]="tool.setSize"
                           [formControl]="form.controls.setSize"
                           [showErrors]="showValidations"
                           (inputChange)="changeSetSize($event)"
                           label="{{'admin.tools.form.labels.setSize' | translate }}">
                </app-input>
            </div>
            <div class="col s4">
                <app-input formControlName="nrOfSpareTools"
                           [(ngModel)]="tool.nrOfSpareTools"
                           [formControl]="form.controls.nrOfSpareTools"
                           [showErrors]="showValidations"
                           label="{{'admin.tools.form.labels.spareSize' | translate }}">
                </app-input>
            </div>
        </ng-container>
    </div>
    <div class="row">
        <app-input
            formControlName="name"
            labelAlign="left"
            [(ngModel)]="tool.name"
            [formControl]="form.controls.name"
            [showErrors]="showValidations || form.controls.name.dirty"
            placeholder="{{ 'admin.tools.form.labels.name' | translate }}"
            label="{{ 'admin.tools.form.labels.name' | translate }}">
        </app-input>
        <app-textarea formControlName="description"
                   labelAlign="left"
                   [formControl]="form.controls.description"
                   [showErrors]="showValidations"
                   placeholder="{{'admin.tools.form.labels.description' | translate }}"
                   label="{{'admin.tools.form.labels.description' | translate }}">
        </app-textarea>
        <app-dropdown-autocomplete labelAlign="left"
                                   [formControl]="form.controls.owner"
                                   [showErrors]="showValidations"
                                   [items]="owners"
                                   [resetSelectionOnItemChange]="false"
                                   [appendTo]="'body'"
                                   [label]="'admin.tools.form.labels.owner.label' | translate"
                                   [emptyText]="'admin.tools.form.labels.owner.placeholder' | translate"
                                   (selectItem)="onSelectedOwner($event)"
                                   valueField="id">
        </app-dropdown-autocomplete>
        <app-dropdown-autocomplete formControlName="line"
                                   labelAlign="left"
                                   displayField="name"
                                   valueField="id"
                                   [formControl]="form.controls.line"
                                   [showErrors]="showValidations"
                                   [items]="availableLines"
                                   [appendTo]="'body'"
                                   [label]="'admin.tools.form.labels.line.label' | translate"
                                   [emptyText]="'admin.tools.form.labels.line.placeholder' | translate"
                                   (selectItem)="onSelectLine($event)"
                                   [resetSelectionOnItemChange]="false">
        </app-dropdown-autocomplete>
    </div>
</form>
